// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".file-input__extended[data-v-29ec1fb5] .file-input-container {\n  line-height: 1.4;\n}", ""]);
// Exports
module.exports = exports;
